// import React from "react";
import "./EventOneArtist.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Artist = () => {
  const options = {
    items: 3,
    dots: false,
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
      // Define breakpoints and the number of items to show at each breakpoint
      0: {
        items: 2,
        nav: false,
      },
      768: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4,
      },
      1199: {
        items: 6,
      },
    },
  };
  return (
    <div className="Artist_Events">
      <div className="container">
        <div className="artist_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <span className="music-icon material-symbols-outlined">
                    steps
                  </span>
                </div>
              </div>
              <div>
                <h2 className="title">Athletes</h2>
              </div>
            </div>
            <div className="right">
              <button className="event_one_viewall_button">View All</button>
            </div>
          </div>
          <div className="event-container_artist">
            <OwlCarousel className="owl-theme my_owl_carousel" {...options}>
              <div className="item event-card_artist">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete1.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">Virat Kohli</h5>
              </div>

              <div className="item event-card_artist ">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete2.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">LeBron James</h5>
              </div>

              <div className="item event-card_artist ">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete3.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">Lionel Messi</h5>
              </div>

              <div className="item event-card_artist ">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete4.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">Lakshya Sen</h5>
              </div>

              <div className="item event-card_artist ">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete5.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">Lewis Hamilton</h5>
              </div>

              <div className="item event-card_artist ">
                <div className="image-container_artist">
                  <img
                    src="./assets/img/eventify/athlete6.jpeg"
                    className="event-image_artist"
                  />
                </div>
                <h5 className="contain_artist_name">Novak Djokovic</h5>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Artist;
